import { withInstall } from '../../utils'

import _Page from './src/page.vue'

export const SdPage = withInstall(_Page)
export default SdPage

export * from './src/page'
